import { SpecificationResponseBuilder } from './SpecificationResponseBuilder';
import { PricingSummaryResponseBuilder } from './PricingSummaryResponseBuilder';
import { IBaseArgument } from './IBaseArgument';
import { BaseResponseBuilder } from './BaseResponseBuilder';

export class EnrichedOfferOptionResponseBuilder extends BaseResponseBuilder {
    constructor() {
        super('EnrichedOfferOption');
    }
    public withOfferOptionToken = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['offerOptionToken'] = this.initField(null, args);
        return this;
    }

    public withIsAvailable = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['isAvailable'] = this.initField(null, args);
        return this;
    }

    public withOfferOptionId = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['offerOptionId'] = this.initField(null, args);
        return this;
    }

    public withSupplierOfferOptionCode = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['supplierOfferOptionCode'] = this.initField(null, args);
        return this;
    }

    public withSpecification = (builder: SpecificationResponseBuilder, shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['specification'] = this.initField(builder, args);
        return this;
    }

    public withBookingRequirementRefId = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['bookingRequirementRefId'] = this.initField(null, args);
        return this;
    }

    public withAvailableQuantity = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['availableQuantity'] = this.initField(null, args);
        return this;
    }

    public withPricingSummary = (builder: PricingSummaryResponseBuilder, shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['pricingSummary'] = this.initField(builder, args);
        return this;
    }

    public withOfferId = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['offerId'] = this.initField(null, args);
        return this;
    }

    public withOfferDetailsReference = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['offerDetailsReference'] = this.initField(null, args);
        return this;
    }
}
